<!-- simple-autocomplete-light.component.html -->
<mat-form-field appearance="outline" class="simple-autocomplete-field" [class.opened]="isOpen" [class.not-show-box-errors]="hiddenBoxErrors">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <input
    class="simple-autocomplete-input"
    type="text"
    matInput
    [formControl]="searchControl"
    [placeholder]="placeholder"
    [attr.required]="required ? '' : null"
    [attr.aria-required]="required ? 'true' : null"
    [matAutocomplete]="auto"
    (focus)="onInputFocus()"
    (click)="onInputClick()"
    (blur)="onInputBlur()"
    (keydown.enter)="onEnterPress($event)"
    autocomplete="off"
  />
  <app-enfaf-icon svgIconName="search-dark" iconSize="21px" matPrefix />
  <mat-icon matSuffix class="dropdown-chevron" [class.rotated]="isOpen" (click)="onChevronClick($event)"> expand_more </mat-icon>

  @if (selected) {
    <button [disabled]="disabled" mat-icon-button matSuffix class="clear-button" (click)="clearSelection()" type="button">
      <mat-icon>close</mat-icon>
    </button>
  }

  <mat-autocomplete #auto="matAutocomplete" (opened)="onPanelOpened()" (closed)="onPanelClosed()" [disableRipple]="true">
    @for (option of filteredOptions; track trackByFn($index, option)) {
      <mat-option [value]="null" class="custom-option" (click)="selectOption(option)">
        <div class="option-row">
          <div class="content-column">
            <div class="option-title" [class.selected]="isOptionSelected(option)">{{ option.title }}</div>
            @if (option.subtitle) {
              <div class="option-subtitle">{{ option.subtitle }}</div>
            }
          </div>
          @if (isOptionSelected(option)) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </mat-option>
    }

    <!-- Cargar más -->
    @if (options.length < total && !loading) {
      <div class="load-more-option" (click)="onLoadMoreClick($event)">
        <div class="load-more-content">
          <mat-icon>expand_more</mat-icon>
          Cargar más
        </div>
      </div>
    }

    @if (loading) {
      <div class="loading-option">
        <div class="loading-content">
          <mat-icon>hourglass_empty</mat-icon>
          Cargando...
        </div>
      </div>
    }
  </mat-autocomplete>

  @if (searchControl.errors) {
    <mat-error>{{ errorLabel }}</mat-error>
  }
</mat-form-field>
